import { StorageEntity } from 'shared/types';

export default abstract class StorageService<T extends string> {

    private readonly emptyValue = { value: null };
    private readonly separator = ':';

    private readonly storage: Storage;
    private readonly prefix: StorageEntity;

    public constructor(prefix: StorageEntity, storage: Storage = window.localStorage) {
        this.storage = storage;
        this.prefix = prefix;
    }

    protected getItem<ValueType>(key: T): ValueType | null;
    protected getItem<ValueType>(key: T, fallback?: ValueType): ValueType;
    protected getItem<ValueType>(key: T, fallback?: ValueType | null): ValueType | null {
        const prefixedKey = this.getPrefixedKey(key);
        const rawValue = this.storage.getItem(prefixedKey);
        const fallbackValue = fallback ?? null;

        if (rawValue === null) {
            return fallbackValue;
        }

        try {
            const parsedValue = JSON.parse(rawValue);

            if (parsedValue.value != null) {
                return parsedValue.value;
            }

            return fallbackValue;
        } catch (e) {
            return fallbackValue;
        }
    }

    protected setItem<ValueType>(key: T, value: ValueType): void {
        const storageValue = { value };

        let stringifiedValue: string;

        try {
            stringifiedValue = JSON.stringify(storageValue);
        } catch (e) {
            stringifiedValue = JSON.stringify(this.emptyValue);
        }

        const prefixedKey = this.getPrefixedKey(key);
        this.storage.setItem(prefixedKey, stringifiedValue);
    }

    protected removeItem(key: T): void {
        this.storage.removeItem(key);
    }

    private getPrefixedKey(key: T): string {
        return `${ this.prefix }${ this.separator }${ key }`;
    }

}
